import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  CurrencyType,
  getCurrencyDetails,
} from '../../../../constants/currencies';
import { PngIcon } from '../../../Molecules';

import styles from './BasicPopupContainer.module.css';

export enum PopUpButtonColors {
  WEA_PRIMARY = '#3597E9',
  SUCCESS = '#00a698',
  DANGER = '#EB4D4D',
  CANCEL = '#949494',
}
type BasicPopupContainerProps = {
  children: React.ReactNode;
  onPrimaryButtonClick: () => void;
  primaryButtonLabel?: string;
  primaryButtonFee?: {
    type: CurrencyType;
    amount: number;
  };
  primaryButtonColor?: PopUpButtonColors;
  onSecondaryButtonClick?: () => void;
  secondaryButtonLabel?: string;
};

export const BasicPopupContainer = (props: BasicPopupContainerProps) => {
  const {
    children,
    onPrimaryButtonClick,
    primaryButtonLabel = 'OK',
    primaryButtonFee,
    primaryButtonColor = PopUpButtonColors.SUCCESS,
    onSecondaryButtonClick,
    secondaryButtonLabel = 'Cancel',
  } = props;
  const { t } = useTranslation();

  const makePrimaryButtonLabel = () => {
    if (!primaryButtonFee) {
      return primaryButtonLabel;
    }

    const { icon } = getCurrencyDetails(primaryButtonFee.type);

    return (
      <>
        {t(primaryButtonLabel)}
        <div className={styles.feeContainer}>
          <PngIcon name={icon} width={24} height={24} />
          <span>{primaryButtonFee.amount}</span>
        </div>
      </>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>{children}</div>
      <div className={styles.buttonGroup}>
        {onSecondaryButtonClick && (
          <button
            className={styles.secondaryButton}
            onClick={onSecondaryButtonClick}
            style={{
              backgroundColor: PopUpButtonColors.CANCEL,
              color: 'white',
            }}
          >
            {t(secondaryButtonLabel)}
          </button>
        )}
        <button
          className={styles.primaryButton}
          onClick={onPrimaryButtonClick}
          style={{
            backgroundColor: primaryButtonColor,
            color: 'white',
          }}
        >
          {makePrimaryButtonLabel()}
        </button>
      </div>
    </div>
  );
};
